import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { AnagraficaRubrica, ConfigurazioneAccreditamenti, Evento, Subappalto } from '../../../../../shared/interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-edit-subappalto-accrediti-backoffice',
  templateUrl: './edit-subappalto-accrediti-backoffice.component.html',
  styleUrls: ['./edit-subappalto-accrediti-backoffice.component.css']
})
export class EditSubappaltoAccreditiBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild('uploadVisuraCamerale', { static: false }) uploadVisuraCamerale!: FileUploadComponent;
  @ViewChild('uploadPos', { static: false }) uploadPos!: FileUploadComponent;

  @ViewChild('deleteVisuraCamerale') deleteVisuraCamerale!: ConfirmPopup;
  @ViewChild('deletePos') deletePos!: ConfirmPopup;

  @Input() visible: boolean = false;
  @Input() subappalto?: Subappalto;
  @Input() evento?: Evento;

  @Output() close = new EventEmitter<boolean>();
  
  formSubappalto!: FormGroup;
  configurazione?: ConfigurazioneAccreditamenti;
  rubrica: AnagraficaRubrica[] = [];
  rubricaSel: AnagraficaRubrica | null = null;
  rubricaVisura = '';
  rubricaPos = '';

  attivitaOptions: { attivita: string }[] = [
    { attivita: 'Montaggio' },
    { attivita: 'Smontaggio' },
    { attivita: 'Fornitura impianti' },
    { attivita: 'Noleggio attrezzature' },
    { attivita: 'Audio' },
    { attivita: 'Luci' },
    { attivita: 'Video' },
    { attivita: 'Trasporto' },
    { attivita: 'Allestimento' },
  ];
  attivita_filtrate: { attivita: string }[] = [];

  ngOnInit(): void {
    this.formSubappalto = new FormGroup({
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null, Validators.required),
      attivita: new FormControl(null, Validators.required),      
      visura_camerale: new FormControl(null),
      pos: new FormControl(null),
    });

    this.apiService.getConfigurazioneAccreditamenti().subscribe({
      next: (c) => this.configurazione = c,
      error: () => {},
    });

    this.apiService.getRubrica().subscribe({
      next: (list) => {
        this.rubrica = (list || [])
          .slice()
          .sort((a, b) => (a.ragione_sociale || '').localeCompare(b.ragione_sociale || '', 'it'));
      },
      error: () => { this.rubrica = []; },
    });

    if (this.subappalto) {
      this.formSubappalto.patchValue({
        ragione_sociale: this.subappalto?.ragione_sociale,
        piva: this.subappalto?.piva,
        attivita: this.subappalto?.attivita
          ? this.subappalto.attivita.split(',').map((a) => ({ attivita: a.trim() })).filter((a) => a.attivita)
          : null,
      })
    }
  }

  onFilterAttivita(event: AutoCompleteCompleteEvent) {
    const filtered = [...this.attivitaOptions].filter(
      (a) => a.attivita.toLowerCase().indexOf(event.query.toLowerCase()) == 0,
    );
    this.attivita_filtrate = filtered.length <= 0 ? [{ attivita: event.query }] : filtered;
  }

  onRubrica(sel: AnagraficaRubrica | null) {
    this.rubricaSel = sel;
    if (!sel) {
      this.rubricaVisura = '';
      this.rubricaPos = '';
      return;
    }
    this.formSubappalto.patchValue({
      ragione_sociale: sel.ragione_sociale || '',
      piva: sel.piva || '',
    });
    // Solo se il subappalto non ha già il documento
    const hasVisura = !!(this.subappalto?.visura_camerale && String(this.subappalto.visura_camerale).trim());
    const hasPos = !!(this.subappalto?.pos && String(this.subappalto.pos).trim());
    this.rubricaVisura = !hasVisura ? (sel.visura_camerale || '').toString().trim() : '';
    this.rubricaPos = !hasPos ? (sel.pos || sel.dvr || '').toString().trim() : '';
  }

  private flag(v: unknown): boolean {
    return v === true || v === 1 || v === '1';
  }

  get visuraObbl(): boolean {
    const e = this.evento as any;
    if (e?.obbl_visura_subappalti != null) return this.flag(e.obbl_visura_subappalti);
    return !!e?.obbligatorieta;
  }

  get posObbligatorio(): boolean {
    const e = this.evento as any;
    if (e?.obbl_pos_subappalti != null) return this.flag(e.obbl_pos_subappalti);
    return !!e?.obbligatorieta;
  }

  onClose() {
    this.visible = false;
    this.close.emit(this.visible);
  }

  onDocumento(documento: string) {
    this.apiService.openProtectedFile(documento);
  }

  onOpenDeleteDocumento(event: Event, documento: string) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il documento caricato?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteDocumentoSubappalto(this.subappalto!.id, documento).subscribe({
          next: () => {
            if (documento == 'visura_camerale') this.subappalto!.visura_camerale = '';
            else if (documento == 'pos') this.subappalto!.pos = '';
            if (this.subappalto?.id_evento) {
              this.apiService.setSubappaltiEvento(this.subappalto.id_evento);
              this.apiService.setDocumentiEvento(this.subappalto.id_evento);
            }
          },
          error: (err) => {
            const m = err?.error?.message;
            this.apiService.message('error', 'Errore', typeof m === 'string' ? m : (m?.message || 'Eliminazione non riuscita'));
          },
          complete: () => {
            this.confirmationService.close();
            this.apiService.message('success', 'Eliminazione', 'Il documento è stato rimosso con successo!');
          },
        });
      },
    });
  }

  onDeleteDocumento(tipo: string) {
    if (tipo == 'visura_camerale')
      this.deleteVisuraCamerale.accept();
    else if (tipo == 'pos')
      this.deletePos.accept();
  }

  onCloseDeleteDocumento(tipo: string) {
    if (tipo == 'visura_camerale')
      this.deleteVisuraCamerale.reject();
    else if (tipo == 'pos')
      this.deletePos.reject();
  }

  onEdit() {
    
    let subappalto = new FormData();
    
    subappalto.append("id_evento", (this.subappalto?.id_evento || 0).toString());
    subappalto.append('ragione_sociale', this.formSubappalto.get('ragione_sociale')?.value || '');
    subappalto.append('piva', this.formSubappalto.get('piva')?.value || '');
    subappalto.append(
      'attivita',
      (this.formSubappalto.get('attivita')?.value || [])
        .map((a: { attivita: string }) => a.attivita)
        .join(','),
    );
    subappalto.append('visura_camerale', this.formSubappalto.get('visura_camerale')?.value || '');
    subappalto.append('pos', this.formSubappalto.get('pos')?.value || '');
    subappalto.append('pos_dovuto', this.posObbligatorio ? '1' : '0');
    if (!this.formSubappalto.get('visura_camerale')?.value && this.rubricaVisura) {
      subappalto.append('visura_camerale_ref', this.rubricaVisura);
    }
    if (!this.formSubappalto.get('pos')?.value && this.rubricaPos) {
      subappalto.append('pos_ref', this.rubricaPos);
    }

    this.apiService.updateSubappalto(subappalto, this.subappalto!.id).subscribe({
      next: (data) => {
        this.apiService.setSubappaltiEvento(this.subappalto!.id_evento);
        this.apiService.setDocumentiEvento(this.subappalto!.id_evento);
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.uploadVisuraCamerale.clearUpload();
        this.uploadPos.clearUpload();

        this.formSubappalto.reset();
        this.rubricaSel = null;
        this.rubricaVisura = '';
        this.rubricaPos = '';
        this.formSubappalto.markAsUntouched();
        this.formSubappalto.markAsPristine();    

        this.onClose()
      }
    });    

  }
}
